function linkify(text) {
  if (text) {
    text = text.replace(
      /((https?\:\/\/)|(www\.))(\S+)(\w{2,4})(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/gi,
      function (url) {
        var full_url = url;
        if (!full_url.match('^https?:\/\/')) {
          full_url = 'http://' + full_url;
        }
        return '<a href="' + full_url + '" target="_blank">' + url + '</a>';
      }
    );
  }
  return text;
};

function addPlaylistToElement(playlist_id, element_class, limit, element_id) {

  var player_id = playlist_id;
  var element_class = element_class;
  var limit = limit;
  console.log(element_class);
  var requestOptions = {
    playlistId: playlist_id,
    part: "snippet,contentDetails",
    maxResults: limit
  };
  var request = gapi.client.youtube.playlistItems.list(requestOptions); //all kinds of data API here using only playlistItems (search, playlist etc etc)
  request.execute(function (response) {

    var output = '';
    var output_img = '';
    $.each(response.items, function (key, val) {
      console.log(response.items);
      console.log('Test');
      var video_id = val.snippet.resourceId.videoId;
      var desc = val.snippet.description;
      var linkifyNote = linkify(desc);
      var title = val.snippet.title;
      var channelTitle = val.snippet.channelTitle;
      var publishedAt = val.snippet.publishedAt;
      var videoPublishedAt = val.contentDetails.videoPublishedAt;
      var note = val.contentDetails.note;
      var ytDate = new Date(videoPublishedAt);
      const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
      var ytDay = ytDate.getDate();
      var ytMonth = ytDate.toLocaleString(undefined, { month: 'long' });
      var ytyear = ytDate.getFullYear();

      output += "<div class='yt-item col-3'>";
      output += "<div class='yt-thumbnail' style='background-image: url(https://img.youtube.com/vi/" + video_id + "/sddefault.jpg);'>";
      output += "<a data-fancybox href='https://www.youtube.com/watch?v=" + video_id + "'>";
      output += "<div class='thumb-overlay'></div>";
      output += "<div class='play'></div>";
      output += "</a>";
      output += "</div>";
      //output += "<img id='"+ video_id +"' class='img-fluid img-playlist' width='100%' height='134px' src='https://img.youtube.com/vi/"+ video_id +"/maxresdefault.jpg'>";
      //output += "<iframe class='embed-responsive-item' width='100%' height='133px' src='https://www.youtube.com/embed/"+ video_id +"?list=;"+ player_id +"="+ video_id +"&amp;showinfo=0' frameborder='0' allowfullscreen></iframe>";
      output += "<p class='yt-date'>" + ytMonth + " " + ytDay + ", " + ytyear + "</p>";
      output += "<h3 class='yt-title'>" + title + "</h3>";
      output += "</div>";
    });
    $('#youtube-playList-img').append(output_img);
    //$('#youtube-playList').append(output);
    $(element_class).append(output);

    $('#youtube-playList > div').slice(-6).addClass("hidden-vid");

  }, $('.spinner, .spinner-img').fadeOut(360));
  $("#youtube-player").attr('src', 'https://www.youtube.com/embed/?list=' + player_id + '&amp;showinfo=0');
};